
<mat-dialog-content data-testid="allocate-doctor-dialog" class="mat-dialog-content">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Change Allocated Doctor</h4><i data-testid="allocate-doctor-close" class="fas fa-times pull-right fontL3" (click)="hideModal()"></i>
  </div>
  <div class="modal-body mt-0">
    <div class="col-xs-12">
      <label>Select Other Doctor</label>
      <div class="col-xs-12">
        <input class="form-control" type="text" placeholder="Type here to search..." matInput="matInput" name="selectDoctor" autocomplete="off" [formControl]="autoCompleteDoctorController" [matAutocomplete]="selectedDoctorAuto"/>
        <mat-autocomplete class="search-bar-xs col-xs-12" #selectedDoctorAuto="matAutocomplete">
          <mat-option class="col-xs-12" *ngFor="let option of doctorOptions | async" [value]="option" (onSelectionChange)="autoCompleteOnDoctorSelect(option)">{{option.name}}</mat-option>
        </mat-autocomplete>
      </div>
      <div class="col-xs-12">
        <label>Selected Doctor</label>
        <div>{{selectedDoctor?.get('DoctorDisplayName')}}</div>
      </div>
      <div class="col-xs-8 flex" *ngIf="type === appConfig.Shared.AllocatedDoctorPopup.Type.FOLLOWUP">
        <label class="col-xs-3">Label</label>
        <select [(ngModel)]="label" name="label">
          <option *ngFor="let option of allocatedTeamType" [value]="option.value">{{option.display}}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="pull-right" (click)="save()" [disabled]="!selectedDoctor && !label">Save</button>
  </div>
</mat-dialog-content>
